import { Box, IconButton } from "@mui/material";
import React from "react";
import clsx from "clsx";
import { TextButton } from "../button/TextButton";
import { ChevronLeft } from "lucide-react";
import { TimeUnit, VERTICAL_TRANSITION_WIDTH } from "./ClientNutritionCard";
import { colorSystem } from "../../theme";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "center",
    width: "fit-content",
    margin: theme.spacing(2.3, 20, 0, 0),
    gap: theme.spacing(0.5),

    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-between",
    },

    [theme.breakpoints.down(VERTICAL_TRANSITION_WIDTH)]: {
      width: "100%",
      margin: theme.spacing(2.3, 25, 3, 0),
    },

    [theme.containerQueries.down("sm")]: {
      justifyContent: "space-between",
    },

    [theme.containerQueries.down(VERTICAL_TRANSITION_WIDTH)]: {
      width: "100%",
      margin: theme.spacing(2.3, 25, 3, 0),
    },
  },

  button: {
    backgroundColor: "transparent",
    borderWidth: 0,
    color: theme.palette.text.secondary,
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 700,
    margin: 0,
    padding: theme.spacing(0.8, 1),
    lineHeight: "17px",
    minWidth: 0,
    "&:hover": {
      color: colorSystem.white,
      backgroundColor: theme.palette.secondary.main,
    },
  },

  invisible: {
    visibility: "hidden",
  },

  viewNav: {
    display: "flex",
    gap: theme.spacing(0.5),
  },

  activeButton: {
    color: colorSystem.white,
    backgroundColor: theme.palette.secondary.main,
  },

  headerNav: {
    display: "flex",
    flexWrap: "nowrap",
  },

  navButtonRight: {
    transform: "rotate(180deg)",
  },

  navButton: {
    width: 40,
  },

  actionButton: {
    fontSize: "1rem",
    fontWeight: 600,
    height: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(2),
    },

    [theme.containerQueries.down("sm")]: {
      marginTop: theme.spacing(2),
    },
  },

  smUp: {
    display: "block",

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },

    [theme.containerQueries.down("sm")]: {
      display: "none",
    },
  },

  smDown: {
    display: "none",

    [theme.breakpoints.down("sm")]: {
      display: "block",
    },

    [theme.containerQueries.down("sm")]: {
      display: "block",
    },
  },
}));

interface ButtonNavProps {
  activeButton: string;
  setActiveButton: any;
  navIndex: number;
  setNavIndex: any;
  dataLength: number;
}

export const ButtonNav = (props: ButtonNavProps) => {
  const { activeButton, setActiveButton, navIndex, setNavIndex, dataLength } =
    props;
  const s = useStyles();

  return dataLength ? (
    <Box className={s.buttons}>
      <Box className={s.viewNav}>
        <TextButton
          className={clsx(s.button, activeButton === "day" && s.activeButton)}
          onClick={() => {
            setActiveButton(TimeUnit.DAY);
          }}
        >
          Day
        </TextButton>
        <TextButton
          className={clsx(s.button, activeButton === "week" && s.activeButton)}
          onClick={() => {
            setActiveButton(TimeUnit.WEEK);
          }}
        >
          Week
        </TextButton>
        <TextButton
          className={clsx(s.button, activeButton === "month" && s.activeButton)}
          onClick={() => {
            setActiveButton(TimeUnit.MONTH);
          }}
        >
          Month
        </TextButton>
        <TextButton
          className={clsx(
            s.button,
            activeButton === "alltime" && s.activeButton,
          )}
          onClick={() => {
            setActiveButton(TimeUnit.ALLTIME);
          }}
        >
          <div className={s.smUp}>All time</div>
          <div className={s.smDown}>All</div>
        </TextButton>
      </Box>
      <Box
        className={clsx(s.headerNav, activeButton === "alltime" && s.invisible)}
      >
        <IconButton
          className={s.navButton}
          onClick={() => setNavIndex((prev) => prev - 1)}
          disabled={navIndex === 0 || dataLength === 0}
        >
          <ChevronLeft
            scale={2}
            color={navIndex === 0 || dataLength === 0 ? "grey" : "black"}
          />
        </IconButton>
        <IconButton
          className={clsx(s.navButton, s.navButtonRight)}
          onClick={() => setNavIndex((prev) => prev + 1)}
          disabled={navIndex >= dataLength - 1 || dataLength === 0}
        >
          <ChevronLeft
            scale={2}
            color={
              navIndex >= dataLength - 1 || dataLength === 0 ? "grey" : "black"
            }
          />
        </IconButton>
      </Box>
    </Box>
  ) : (
    <></>
  );
};
